import request from '../index.js'

// 用户管理API - 连接真实后端API
export const userApi = {
  // 获取用户列表 - 使用真实API
  getUsers(params) {
    // 转换参数名：pageSize -> limit
    const queryParams = { ...params }
    if (queryParams.pageSize) {
      queryParams.limit = queryParams.pageSize
      delete queryParams.pageSize
    }
    if (queryParams.size) {
      queryParams.limit = queryParams.size
      delete queryParams.size
    }
    return request({
      url: '/admin/users',
      method: 'get',
      params: queryParams
    })
  },

  // 获取用户详情 - 使用真实API
  getUserById(id) {
    return request({
      url: `/admin/users/${id}`,
      method: 'get'
    })
  },

  // 获取用户详细信息（含债务关系、亲友团）- 使用真实API
  getUserDetail(id) {
    return request({
      url: `/admin/users/${id}/detail`,
      method: 'get'
    })
  },

  // 创建用户 - 使用真实API
  createUser(data) {
    return request({
      url: '/admin/users',
      method: 'post',
      data
    })
  },

  // 更新用户 - 使用真实API
  updateUser(id, data) {
    return request({
      url: `/admin/users/${id}`,
      method: 'put',
      data
    })
  },

  // 删除用户（软删除+匿名化）- 使用真实API
  deleteUser(id, reason = '') {
    return request({
      url: `/admin/users/${id}`,
      method: 'delete',
      data: { reason }
    })
  },

  // 更新用户状态 - 使用真实API
  updateUserStatus(id, status) {
    return request({
      url: `/admin/users/${id}/status`,
      method: 'patch',
      data: { status }
    })
  },

  // 搜索用户 - 使用真实API
  searchUsers(params) {
    const queryParams = { ...params }
    if (queryParams.pageSize) {
      queryParams.limit = queryParams.pageSize
      delete queryParams.pageSize
    }
    return request({
      url: '/admin/users/search',
      method: 'get',
      params: queryParams
    })
  },

  // 获取用户统计 - 使用真实API
  getUserStats() {
    return request({
      url: '/admin/users/stats',
      method: 'get'
    })
  }
}

export default userApi
